const initialStateAccessLevel = {
    access_level: [],
    access_level_updated: false,
};

export default initialStateAccessLevel;